import { saveTheme } from '../../components/dashboard-b2b/theme'

export function setDashboard(state, dashboard) {
    state.dashboard = dashboard
}

export function setLoading(state, loading) {
    state.loading = loading
}

export function setMonths(state, months) {
    state.params.months = months
}

export function setTheme(state, theme) {
    state.theme = theme
    saveTheme(theme)
}

// Fusiona las gráficas que devolvió el backend con filtro (solo las filtrables) sobre dashboard.charts.
export function mergeCharts(state, charts) {
    if (!state.dashboard) {
        return
    }

    state.dashboard = {
        ...state.dashboard,
        charts: {
            ...state.dashboard.charts,
            ...charts
        }
    }
}

export function setFilterLoading(state, loading) {
    state.filterLoading = loading
}

// Reemplaza el filtro activo (nunca se combinan).
export function setFilter(state, { type, id, label }) {
    state.filter = { type, id, label }
}

export function clearFilter(state) {
    state.filter = { type: null, id: null, label: null }
}

export function setSellerMaxValue(state, value) {
    state.sellerMaxValue = value
}

export function setRefreshing(state, refreshing) {
    state.refreshing = refreshing
}

export function setColorMaps(state, colorMaps) {
    state.colorMaps = colorMaps
}
